import React from 'react';

export function SearchForm({ 
  appSearchQuery, 
  isSearching, 
  onSearchQueryChange, 
  onSearchSubmit 
}) {
  return (
    <div className="max-w-4xl mx-auto mb-12 sm:mb-16">
      <div className="relative group">
        <div className="absolute -inset-1 bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500 rounded-3xl blur-lg opacity-20 group-hover:opacity-30 transition-opacity duration-300"></div>
        <form onSubmit={onSearchSubmit} className="relative bg-white/95 backdrop-blur-xl rounded-3xl p-4 sm:p-6 lg:p-12 shadow-xl border border-white/60">
          <div className="mb-6 sm:mb-8">
            <div className="relative">
              <textarea
                rows={6}
                style={{ minHeight: '180px' }}
                className={`w-full px-4 py-4 sm:px-6 sm:py-6 text-base sm:text-lg lg:text-xl border-2 border-gray-200 rounded-2xl focus:ring-4 focus:ring-indigo-500/20 focus:border-indigo-500 resize-none text-gray-900 placeholder-gray-400 transition-all duration-300 bg-gray-50/50 backdrop-blur-sm leading-relaxed ${isSearching ? 'opacity-60 cursor-not-allowed' : ''}`}
                placeholder="Describe what you're looking for..."
                value={appSearchQuery}
                onChange={onSearchQueryChange}
                disabled={isSearching}
              />
            </div>
          </div>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4 mb-6 sm:mb-8">
            <button
              type="submit"
              disabled={isSearching || !appSearchQuery.trim()}
              className="group relative w-full sm:w-auto px-8 sm:px-12 py-4 sm:py-5 bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 text-white font-bold text-base sm:text-lg rounded-2xl shadow-xl hover:shadow-2xl disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-500 transform hover:scale-105 hover:-translate-y-1"
            >
              <div className="absolute inset-0 bg-gradient-to-r from-indigo-700 via-purple-700 to-pink-700 rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              <div className="relative flex items-center justify-center">
                {isSearching ? (
                  <>
                    <div className="w-5 h-5 sm:w-6 sm:h-6 border-2 border-white border-t-transparent rounded-full animate-spin mr-2 sm:mr-3"></div>
                    <span className="text-sm sm:text-base">Searching...</span>
                  </>
                ) : (
                  <>
                    <svg className="w-5 h-5 sm:w-6 sm:h-6 mr-2 sm:mr-3 transition-transform group-hover:rotate-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                    </svg>
                    Find My App
                  </>
                )}
              </div>
            </button>
          </div>

          {/* Quick Examples */}
          <div className="text-center">
            <p className="text-xs sm:text-sm text-gray-500 mb-3 sm:mb-4 font-medium">Quick examples to try:</p>
            <div className="flex flex-wrap justify-center gap-2 sm:gap-3">
              {[
                'App to split bills with roommates',
                'Tool to track employee schedules',
                'Way to coordinate group dinner plans'
              ].map((example, index) => (
                <button
                  key={index}
                  type="button"
                  onClick={() => onSearchQueryChange({ target: { value: example } })}
                  disabled={isSearching}
                  className={`px-3 sm:px-4 py-2 bg-gradient-to-r from-indigo-50 to-purple-50 text-indigo-700 rounded-full text-xs sm:text-sm font-medium hover:from-indigo-100 hover:to-purple-100 transition-all duration-300 border border-indigo-200 hover:border-indigo-300 transform hover:scale-105 ${isSearching ? 'opacity-50 cursor-not-allowed hover:scale-100' : ''}`}
                >
                  "{example}"
                </button>
              ))}
            </div>
          </div>
        </form>
      </div>
    </div>
  );
} 